export const ACCOUNT_TYPES_LIST = [
  'bank account',
  'credit card',
  'investment account',
  'household',
  'person',
]
